import React from "react"
export function PaperlessClaim(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M17.282 1l.718.718-2.286 2.286v.002l-1.016 1.015-3.126 3.124-1.014 1.016-5.92 5.918-1.015 1.018v-.003L1.719 18 1 17.282l2.623-2.624L3.62 3.405c0-.257.191-.47.44-.503l.068-.005h11.079c.053 0 .105.008.154.024L17.28 1zm-1.567 5.878l.003 6.377a.508.508 0 01-.097.299l-.052.06-3.694 3.695a.508.508 0 01-.279.142l-.08.006h-6.38l1.016-1.016h5.041v-2.878c0-.257.191-.47.44-.503l.068-.005h2.99l.01-.01-.001-5.152 1.015-1.015zm-2.04 7.193H12.21v1.466l1.467-1.466zm.694-10.158H4.636l.003 9.73L9.12 9.16H6.283V8.146h3.853l1.693-1.694H6.283V5.437h6.562l1.524-1.524z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__paperless-claim"
        />
      </g>
    </svg>
  )
}
